import { DeviceManagerRepositoryInterface } from "@/data/persistences/repositories/contracts/DeviceManagerRepositoryInterface";
import { DeviceManager } from "@/domain/entities/DeviceManager";
import { injectable } from "tsyringe";

@injectable()
export class DeviceManagerPresenter {
  private repository: DeviceManagerRepositoryInterface

  constructor(repository: DeviceManagerRepositoryInterface) {
    this.repository = repository
  }
  
  public getList(): Promise<DeviceManager[]> {
    return this.repository.getList()
  }

  public logout(id: number): Promise<boolean> {
    return this.repository.logout(id)
  }

}